import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, Transition as _Transition, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43f531be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg w-100 h-100 d-flex" }
const _hoisted_2 = { class: "col-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "",
  class: "logo"
}, null, -1))
const _hoisted_4 = { class: "col-9 form" }
const _hoisted_5 = { class: "d-flex justify-content-end" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-f icon-close fs-18 mx-1 icon-color" }, null, -1))
const _hoisted_7 = { class: "inputs-group" }
const _hoisted_8 = { class: "header" }
const _hoisted_9 = { class: "d-block input-label" }
const _hoisted_10 = { class: "d-block input-label" }
const _hoisted_11 = { class: "password-input" }
const _hoisted_12 = ["type"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { opacity: "0.4" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19.2359 6.29743C19.3365 6.11208 19.3365 5.88789 19.2359 5.70254C17.3911 2.30591 13.7927 0 9.6557 0C5.51868 0 1.9203 2.30594 0.0754942 5.70254C-0.0251647 5.88789 -0.0251647 6.11208 0.0754942 6.29743C1.92033 9.69406 5.51862 12 9.65567 12C13.7927 12 17.391 9.69406 19.2359 6.29743ZM9.65567 10.6024C7.11383 10.6024 5.05329 8.54181 5.05329 6C5.05329 3.45819 7.11383 1.39758 9.65567 1.39758C12.1975 1.39758 14.2581 3.45816 14.2581 6C14.2581 8.54184 12.1975 10.6024 9.65567 10.6024Z",
    fill: "#030229"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.65603 3.6543C9.46241 3.6543 9.27437 3.67793 9.09442 3.72214C9.27873 3.93545 9.39049 4.21322 9.39049 4.51725C9.39049 5.18936 8.84564 5.73425 8.1735 5.73425C7.86947 5.73425 7.5917 5.62251 7.37839 5.43817C7.33418 5.61812 7.31055 5.80616 7.31055 5.99978C7.31055 7.29515 8.36065 8.34522 9.65599 8.34522C10.9513 8.34522 12.0014 7.29512 12.0014 5.99978C12.0014 4.70443 10.9514 3.6543 9.65603 3.6543Z",
    fill: "#030229"
  })
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "pb-1 pt-2" }
const _hoisted_16 = {
  type: "submit",
  class: "base-btn"
}
const _hoisted_17 = {
  class: "modal fade show w-100",
  style: {"height":"auto","display":"block","top":"-125px"},
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_18 = { class: "modal-dialog" }
const _hoisted_19 = { class: "modal-content" }
const _hoisted_20 = { class: "modal-body" }
const _hoisted_21 = { class: "row mt-3" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = {
  class: "d-block input-label",
  for: ""
}
const _hoisted_24 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBoxInput = _resolveComponent("CheckBoxInput")!
  const _component_LanguageSwitcher = _resolveComponent("LanguageSwitcher")!
  const _component_OverlayModal = _resolveComponent("OverlayModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          style: {"opacity":"0","width":"25px","height":"20px","cursor":"default","float":"inline-start"},
          onClick: _cache[0] || (_cache[0] = () => {_ctx.openStorageModal = true})
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.isElectron())
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "d-flex align-items-center exit-btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeApplication && _ctx.closeApplication(...args)))
              }, [
                _hoisted_6,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.exit")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("form", {
          class: "loginForm",
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t("cashier.login.header")), 1),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("cashier.login.username")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.username) = $event)),
                autocomplete: "username",
                class: "input",
                type: "text"
              }, null, 512), [
                [_vModelText, _ctx.username]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.t("cashier.login.password")), 1),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
                  autocomplete: "current-password",
                  class: "input",
                  type: _ctx.inputType
                }, null, 8, _hoisted_12), [
                  [_vModelDynamic, _ctx.password]
                ]),
                (_openBlock(), _createElementBlock("svg", {
                  class: "eye-icon",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.switchVisibility && _ctx.switchVisibility(...args))),
                  width: "20",
                  height: "12",
                  viewBox: "0 0 20 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, _hoisted_14))
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_CheckBoxInput, {
                class: "login-remember-me",
                modelValue: _ctx.rememberMe,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.rememberMe) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("login.remember-me")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("button", _hoisted_16, _toDisplayString(_ctx.t("cashier.login.sign-in")), 1)
          ])
        ], 32),
        _createVNode(_component_LanguageSwitcher, { class: "w-auto justify-content-center" })
      ])
    ]),
    _createVNode(_component_OverlayModal, { isOpen: _ctx.openStorageModal }, {
      default: _withCtx(() => [
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('cashier.shift.stationTitle')), 1),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('cashier.station.cashierGuid')), 1),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.stationData.cashierGuid) = $event)),
                          type: "text",
                          class: "input w-100"
                        }, null, 512), [
                          [_vModelText, _ctx.stationData.cashierGuid]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-secondary",
                      onClick: _cache[8] || (_cache[8] = () => { _ctx.openStorageModal = false })
                    }, _toDisplayString(_ctx.$t('cashier.shift.close')), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      style: {"background-color":"#005585"},
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.saveStationDataInLocalStorage && _ctx.saveStationDataInLocalStorage(...args)))
                    }, _toDisplayString(_ctx.$t('cashier.shift.save')), 1)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["isOpen"])
  ], 64))
}